module.exports = __webpack_public_path__ + "static/media/new-window-white.85063978.svg";